var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Fragment } from 'react';
import { WebLink } from '@/components/functional/Link/WebLink/WebLink';
/**
 * 動的にリンク・非リンクを切り替えるコンポーネント
 * @param props
 * @constructor
 */
export const DynamicLink = (props) => {
    const { children, className, externalLinkAttributes, isNestedLink, noLinkElement: NoLinkComponent, noLinkElementAttributes, objectClassName, onClick, onClickNoLink, routerLinkAttributes, target, to, } = props;
    // リンクでない場合、data属性用に値を取り出す
    const _a = noLinkElementAttributes || {}, { dataAttributes: noLinkElementDataAttributes } = _a, otherNoLinkElementAttributes = __rest(_a, ["dataAttributes"]);
    // aタグがネスト状態になる場合 <object> タグでラップする
    const LinkWrapper = isNestedLink ? 'object' : Fragment;
    // リンクを無効化している場合
    if (NoLinkComponent) {
        return (_jsx(NoLinkComponent, Object.assign({ className: clsx(className), onClick: onClickNoLink }, noLinkElementDataAttributes, otherNoLinkElementAttributes, { children: children })));
    }
    // 外部・内部リンクに応じてコンポーネントを使い分ける
    return (_jsx(LinkWrapper, Object.assign({}, (isNestedLink ? { className: clsx(objectClassName) } : {}), { children: _jsx(WebLink, Object.assign({ className: className, externalLinkAttributes: externalLinkAttributes, onClick: onClick, routerLinkAttributes: routerLinkAttributes, target: target, to: to }, { children: children })) })));
};
